import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconMagnify = _resolveComponent("IconMagnify")
  const _component_NcTextField = _resolveComponent("NcTextField")

  return (_openBlock(), _createBlock(_component_NcTextField, {
    ref: "searchConversations",
    modelValue: $options.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.modelValue) = $event)),
    "aria-label": $props.placeholderText,
    "aria-describedby": $props.ariaDescribedby,
    placeholder: $props.placeholderText,
    "show-trailing-button": $props.isFocused,
    "trailing-button-label": $options.cancelSearchLabel,
    class: "search-box",
    "label-outside": "",
    onFocus: $options.handleFocus,
    onBlur: $options.handleBlur,
    onTrailingButtonClick: $options.abortSearch,
    onKeydown: _withKeys($options.abortSearch, ["esc"])
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_IconMagnify, { size: 16 })
    ]),
    _: 1
  }, 8, ["modelValue", "aria-label", "aria-describedby", "placeholder", "show-trailing-button", "trailing-button-label", "onFocus", "onBlur", "onTrailingButtonClick", "onKeydown"]))
}